import React from 'react'

import Image from 'next/image'

import { SectionContainer } from 'Components/Blocks'
import AppearingWrapper from 'Components/Blocks/AppearingWrapper'
import { Column, Row, Text } from 'Components/UI'

import { BackgroundImage } from 'Assets/Images/Sections/ThankYouHeroSection'
import { StripedCircleSvg } from 'Assets/Svg'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import { useResponsiveLayout } from 'Hooks'

import { Container, Overlay, Title } from './styles'

function AboutUsHeroSection() {
  const { isMobile } = useResponsiveLayout()

  return (
    <SectionContainer>
      <Row fullWidth justifyCenter px={LANDING_CONTENT_PX}>
        <Container
          minHeight={['230px', '230px', '350px']}
          mt={5}
          px={[6, 6, 14, 14, 21]}
          py={[14, 14, 14, 14, 21]}
        >
          <Image alt="" src={BackgroundImage} />

          <Overlay />

          <Column
            alignCenter={isMobile}
            alignStart={!isMobile}
            fullHeight
            gap={6}
            justifyCenter
            width={[1, 1, 1 / 2]}
          >
            <AppearingWrapper centered={isMobile} kind="expand">
              <Title flexDirection={['column', 'column', 'row']}>
                {StripedCircleSvg()}

                <Text as="h1" bold center={isMobile} inverse screen18>
                  Form submitted
                </Text>
              </Title>
            </AppearingWrapper>

            <Text
              as="h2"
              bold
              center={isMobile}
              inverse
              nowrap
              screen40={isMobile}
              screen52={!isMobile}
            >
              Thank You
            </Text>
          </Column>
        </Container>
      </Row>
    </SectionContainer>
  )
}

export default AboutUsHeroSection
